<div class="users">
  <app-page-header
    (searchEvent)="hnadleSearch($event)"
    searchPlaceholder="Search by name or email..."
    [pageTitle]="'Users'"
    [numberOfItem]="totalUser"
    [loading]="
      isLoading && (userFilter | async)?.pageNumber === 1 && !totalUser
    "
  >
    <button class="button" [routerLink]="['/add-user']" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span>User</span>
    </button>
  </app-page-header>

  <div>
    <div class="table-block">
      <div class="table-block__wrap">
        <table>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Action</th>
          </tr>
          <ng-container
            *ngIf="
              isLoading && (userFilter | async)?.pageNumber === 1;
              else userList
            "
          >
            <ng-container *ngFor="let i of [].constructor(10)">
              <tr>
                <td>
                  <app-skeleton
                    height="15px"
                    width="100px"
                    margin="0"
                  ></app-skeleton>
                </td>
                <td>
                  <app-skeleton
                    height="15px"
                    width="100%"
                    margin="0"
                  ></app-skeleton>
                </td>
                <td>
                  <app-skeleton
                    height="15px"
                    width="100%"
                    margin="0"
                  ></app-skeleton>
                </td>
                <td>
                  <app-skeleton
                    height="15px"
                    width="100%"
                    margin="0"
                  ></app-skeleton>
                </td>
                <td class="is-action">
                  <div class="table-block__action flex align-center">
                    <app-skeleton
                      height="25px"
                      width="50px"
                      margin="0"
                      radius="28px"
                    ></app-skeleton>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="statusUpdateUserId">
  <app-confirmation-modal
    primaryButtonText="Cancel"
    secondaryButtonText="Yes"
    [message]="
      prevStatus
        ? 'Are you sure you want to deactivate this user?'
        : 'Are you sure you want to activate this user?'
    "
    caption="Confirmation"
    (onPrimaryButtonClick)="closeStatusUpdateModal()"
    (onSecondaryButtonClick)="prevStatus ? deleteUser() : activateUser()"
    [secondaryButtonLoading]="statusUpdateLoading"
  ></app-confirmation-modal>
</ng-container>

<ng-template #noDataFound>
  <tr>
    <td colspan="5">
      <div class="table-block__nodata">No data found</div>
    </td>
  </tr>
</ng-template>

<ng-template #userList>
  <ng-container *ngIf="users.length > 0; else noDataFound">
    <ng-container *ngFor="let user of users; let i = index">
      <tr
        inViewport
        [lastElement]="users.length === i + 1"
        (elementIsVisible)="loadMoreIfLastIndex()"
      >
        <td>{{ user.id }}</td>
        <td>{{ user.name ?? "-" }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.role | titlecase }}</td>
        <td class="is-action">
          <div
            class="table-block__action flex align-center"
            *ngIf="userRoles.EMPLOYEE === user.role"
          >
            <app-switch-button
              [checked]="user.isActive"
              (onClick)="onUserStatusUpdate(user.id, user.isActive)"
              [isDisabled]="true"
            ></app-switch-button>
          </div>
        </td></tr
    ></ng-container>
    <tr *ngIf="isLoading">
      <td>
        <app-skeleton height="15px" width="100px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td class="is-action">
        <div class="table-block__action flex align-center">
          <app-skeleton
            height="25px"
            width="50px"
            margin="0"
            radius="28px"
          ></app-skeleton>
        </div>
      </td>
    </tr>
  </ng-container>
</ng-template>
